import { initialRootState } from '../initialRootState';
import { ESubscriptionsActionType, ISubscriptionsAction } from './actions';
import { IAutoRenewalStatus, ISubscriptions } from './types';

export type ISubscriptionsState = ISubscriptions & IAutoRenewalStatus;

export const subscriptionsReducer = (
  currentState: ISubscriptionsState = initialRootState.subscription,
  action: ISubscriptionsAction
): ISubscriptionsState => {
  switch (action.type) {
    case ESubscriptionsActionType.GET_SUCCESS:
    case ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS_SUCCESS:
      return {
        ...currentState,
        ...action.payload,
      };
    default:
      return currentState;
  }
};
